import { POPULATE_COLUM_TYPE, STORE_COLUM_TYPE, MAKE_COLUM_TYPE } from '../constants';
import { formatText } from './formatText';
import { getPopulatedField } from './getPopulatedFields';
import { getStoreField } from './getStoreField';
import { getMakeField } from './getMakeField';
import { IGetFormattedText } from './types';

/**
 * Will return the string formatted to use in the
 * row of the table
 *
 * @param {IGetFormattedText} {
 *     type, type of the column
 *     field, field where to get data
 *     item, object that is render
 *     column, options of the column
 * }
 * @return {*}
 */
export const getFormattedText = ({
    type,
    field,
    item,
    column,
}: IGetFormattedText): string => {
    const { capitalize } = column;

    let text = '- - -';

    switch (type) {
        case POPULATE_COLUM_TYPE:
            text = getPopulatedField(field, item);
            break;
        case STORE_COLUM_TYPE:
            text = getStoreField(item);
            break;
        case MAKE_COLUM_TYPE:
            text = getMakeField(item);
            break;
        default:
            if (field in item) text = item[field];
    }

    return formatText(text, type, capitalize);
};
